"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CHART_JS_GENERAL_CONFIG = exports.STROKE_STYLE = exports.CurveType = void 0;
/**
 * See D3 documentation for examples of curve types
 * https://github.com/d3/d3-shape#curveLinear
 */
var CurveType;
(function (CurveType) {
    CurveType["LINEAR"] = "curveLinear";
    CurveType["MONOTONE_X"] = "curveMonotoneX";
    CurveType["MONOTONE_Y"] = "curveMonotoneY";
    CurveType["STEP"] = "curveStep";
    CurveType["STEP_AFTER"] = "curveStepAfter";
    CurveType["STEP_BEFORE"] = "curveStepBefore";
})(CurveType = exports.CurveType || (exports.CurveType = {}));
var STROKE_STYLE;
(function (STROKE_STYLE) {
    STROKE_STYLE["DASHED"] = "dashed";
    STROKE_STYLE["SOLID"] = "solid";
})(STROKE_STYLE = exports.STROKE_STYLE || (exports.STROKE_STYLE = {}));
// CHART.JS GENERAL CONFIG
var CHART_JS_GENERAL_CONFIG;
(function (CHART_JS_GENERAL_CONFIG) {
    CHART_JS_GENERAL_CONFIG["GRID_COLOR"] = "#dbdbdb";
    CHART_JS_GENERAL_CONFIG["POINTS_COLOR_DEFAULT"] = "#5482ab";
    CHART_JS_GENERAL_CONFIG["POINTS_COLOR_SELECTED"] = "#fa6400";
    CHART_JS_GENERAL_CONFIG["LINE_GRAPH"] = "#5482ab";
    CHART_JS_GENERAL_CONFIG["LINE_GRAPH_TWO"] = "#e87211";
    CHART_JS_GENERAL_CONFIG["STROKE_ON_HOVER"] = "#4a4a4a";
    CHART_JS_GENERAL_CONFIG["LINE_GRAPH_THREE"] = "#989898";
    CHART_JS_GENERAL_CONFIG["LABELS"] = "#4a4a4a";
    CHART_JS_GENERAL_CONFIG["LEGENDS"] = "#818181";
})(CHART_JS_GENERAL_CONFIG = exports.CHART_JS_GENERAL_CONFIG || (exports.CHART_JS_GENERAL_CONFIG = {}));
